import { render, staticRenderFns } from "./VideoBlobControls.vue?vue&type=template&id=ea1ce416&scoped=true"
import script from "./VideoBlobControls.vue?vue&type=script&lang=js"
export * from "./VideoBlobControls.vue?vue&type=script&lang=js"
import style0 from "./VideoBlobControls.vue?vue&type=style&index=0&id=ea1ce416&prod&scoped=true&lang=css"
import style1 from "./VideoBlobControls.vue?vue&type=style&index=1&id=ea1ce416&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1ce416",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VSlider,VSpacer})
